import { updateProfileDataThunk } from '../../../../store/workspace/thunks';
import { useDispatch, useSelector } from '../../../../store/store';
import { ProfilePatch } from '../types';
import {
    selectProfileData,
    selectUpdatingProfileData,
} from '../../../../store/workspace/selectors';

/**
 * Reads the applicant's profile and writes changes back to it.
 *
 * The profile endpoint replaces the whole record, so a patch is merged onto the
 * profile currently in the store. `kyc`, `matchedJobs` and `setting` are managed
 * by the backend and are dropped from the payload.
 */
export const useProfileUpdate = () => {
    const dispatch = useDispatch();
    const profile = useSelector(selectProfileData);
    const isSaving = useSelector(selectUpdatingProfileData);

    /** Resolves to `true` once the change is stored — a failure is reported by the store. */
    const saveProfile = async (patch: ProfilePatch): Promise<boolean> => {
        if (!profile) return false;
        const { kyc, matchedJobs, setting, ...current } = profile;

        try {
            await dispatch(updateProfileDataThunk({ ...current, ...patch })).unwrap();
            return true;
        } catch {
            return false;
        }
    };

    return { profile, isSaving, saveProfile };
};
